import styled from 'styled-components';
import { themeColor } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';

export const AvatarBoxPositionWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 1080px;
  margin: auto;
  max-width: 1440px;
`;

export const PhoneWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 0;
`;

export const AvatarContainer = styled.div<{ bottom: string; left: string }>`
  position: absolute;
  left: ${props => props.left};
  bottom: ${props => props.bottom};
`;

export const Phone = styled.div`
  border: 18px solid ${themeColor('mono7')};
  box-shadow: 0px 24px 48px rgba(255, 236, 235, 0.5);
  background-color: rgba(17, 16, 16, 0.6);
  width: 585px;
  height: 1182px;
  display: flex;
  justify-content: center;
  border-radius: 70px 70px 0px 0px;
  background-size: 548px 734px;
  background-repeat: no-repeat;
  position: absolute;
  bottom: -250px;
  overflow: hidden;
`;

export const PhoneScreen = styled.div<{ zIndex: string }>`
  border-radius: 58px 58px 0px 0px;
  background: ${`linear-gradient(180deg, rgba(255, 255, 255, 0.04) 34.9%, rgba(51, 50, 50, 0.282071) 73.95%, rgba(39, 39, 39, 0.4) 100%),url(${cloudAssetUrl(
    'app/attendees-list/attendee_photo.jpg'
  )})`};
  background-size: 554px 760px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  z-index: ${props => props.zIndex};
  width: 554px;
  height: 650px;
`;

export const BlackTransparancy = styled.div`
  background-color: rgba(17, 16, 16, 0.6);
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 520px;
`;

export const PhoneTextWrapper = styled.div`
  position: absolute;
  bottom: 270px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  max-width: 440px;
  margin: auto;
`;
